/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function AlarmClockIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="alarm-clock"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <circle cx={12} cy={12} r={7.852} stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M16.636 18.337L18 20.5" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 7L12 12" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 12L14 14" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M7.364 18.337L6 20.5" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M8 5L7.569 4.353C6.757 3.136 5.035 2.965 4 4C2.965 5.035 3.136 6.757 4.353 7.569L5 8" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M16 5L16.431 4.353C17.243 3.136 18.965 2.965 20 4C21.035 5.035 20.864 6.757 19.647 7.569L19 8" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
